import { useContext, useState } from 'react';
import ReactPageScroller from 'react-page-scroller';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Context from '../../context';
import {
  SekilasTentangKami,
  Fasilitas,
  TarifStruk,
  BeritaHome,
  Footer,
} from '../../components';

const DataNav = [
  {
    title: 'Beranda',
    titleEn: 'Home',
    link: '/',
    exact: true,
  },
  {
    title: 'Tentang Kami',
    titleEn: 'About Us',
    link: '/tentang-kami',
    exact: false,
    children: [
      {
        title: 'Sejarah Perusahaan',
        titleEn: 'Company History',
        link: '/tentang-kami/sejarah-perusahaan',
        exact: true,
      },
      {
        title: 'Visi & Misi',
        titleEn: 'Vision & Mission',
        link: '/tentang-kami/visi-misi',
        exact: true,
      },
      {
        title: 'Struktur Organisasi',
        titleEn: 'Organization Structure',
        link: '/tentang-kami/struktur-organisasi',
        exact: true,
      },
    ],
  },
  {
    title: 'Jalan Tol Kami',
    titleEn: 'Our Toll Road',
    link: '/jalan-tol-kami',
    exact: false,
    children: [
      {
        title: 'Informasi Tol',
        titleEn: 'Toll Information',
        link: '/jalan-tol-kami/informasi-tol',
        exact: true,
      },
      {
        title: 'Teknologi Kami',
        titleEn: 'Our Technology',
        link: '/jalan-tol-kami/teknologi-kami',
        exact: true,
      },
      {
        title: 'Live CCTV',
        titleEn: 'Live CCTV',
        link: '/jalan-tol-kami/live-cctv',
        exact: true,
      },
      {
        title: 'Virtual Tour Toll Road',
        titleEn: 'Virtual Tour Toll Road',
        link: '/jalan-tol-kami/virtual-tour-toll-road',
        exact: true,
      },
    ],
  },
  {
    title: 'Ruang Berita',
    titleEn: 'News Room',
    link: '/ruang-berita',
    exact: false,
    children: [
      {
        title: 'Berita',
        titleEn: 'News',
        link: '/ruang-berita/berita',
        exact: true,
      },
      {
        title: 'Aktifitas',
        titleEn: 'Activity',
        link: '/ruang-berita/kegiatan',
        exact: true,
      },
      {
        title: 'Pengumuman',
        titleEn: 'Announcement',
        link: '/ruang-berita/pengumuman',
        exact: true,
        children: [
          {
            title: 'Lowongan Pekerjaan',
            titleEn: 'Job Vacancy',
            link: '/ruang-berita/lowongan-pekerjaan',
            exact: true,
          },
          {
            title: 'Pengadaan Barang / Jasa',
            titleEn: 'Procurement of Goods / Services',
            link: '/ruang-berita/pengadaan-barang-jasa',
            exact: true,
          },
          {
            title: 'Pengumuman Lainnya',
            titleEn: 'Other Announcement',
            link: '/ruang-berita/pengumuman-lainnya',
            exact: true,
          },
        ],
      },
    ],
  },
];

const HomeItem = () => {
  const context = useContext(Context);
  const currentLang = context.getLang();
  const isId = currentLang === 'ID';
  return (
    <>
      <div style={{ height: 91 }} />
      <SekilasTentangKami isId={isId} />
      <Fasilitas isId={isId} />
      <TarifStruk isId={isId} />
      <BeritaHome isId={isId} />
      <Footer dataNav={DataNav} isId={isId} />
    </>
  );
};

const Home = () => {
  const [state, setState] = useState(0);
  const context = useContext(Context);
  const currentLang = context.getLang();
  const isId = currentLang === 'ID';
  const upXl = useMediaQuery('(min-width:1919px)');

  if (!upXl) {
    return <HomeItem />;
  }

  return (
    <ReactPageScroller
      pageOnChange={(page) => setState(page)}
      customPageNumber={state}
    >
      <SekilasTentangKami isId={isId} />
      <Fasilitas isId={isId} />
      <TarifStruk isId={isId} />
      <BeritaHome isId={isId} />
      <div
        style={{
          backgroundColor: 'rgb(66, 66, 68)',
          height: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-end',
          // paddingTop: 127,
        }}
      >
        <Footer dataNav={DataNav} isId={isId} />
      </div>
    </ReactPageScroller>
  );
};

export default Home;
